export default __webpack_public_path__ + "static/media/rebase.3332b4ff.svg";